var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"swatch_wpml_language_selector-4"}},[_c('ul',{staticClass:"inline"},_vm._l((_vm.languages),function(lang){return _c('li',{key:lang,attrs:{"value":lang}},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.switchLang(lang)}}},[_c('img',{attrs:{"src":require('../../assets/images/flags/'+lang+'.png')}})])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }